var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentValue)?_c('div',{staticClass:"mask",on:{"click":_vm.onClose}}):_vm._e(),_c('div',{staticClass:"popup_box",class:[_vm.type == 1000 ? 'popup_bottom' : 'popup_center'],style:({ opacity: _vm.opacity, transform: _vm.transform })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }